module.exports = __webpack_public_path__ + "static/media/xudinglaodonghetong2.bd437973.png";